<template>
  <v-tooltip
    :open-delay="tooltipDelay"
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span v-on="on" v-if="enableToolTip">
        <v-checkbox
          v-bind="computedProps"
          v-on="computedListeners"
          :on-icon="onIcon"
          :off-icon="offIcon"
        />
      </span>
      <v-checkbox
        v-bind="computedProps"
        v-on="computedListeners"
        :on-icon="onIcon"
        :off-icon="offIcon"
        v-else
      />
    </template>
    <!-- RAW形式で文字列展開 -->
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VCheckbox } from 'vuetify/lib'

/**
 * @file DDv2用チェックボックス
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須制御有無
 * @vue-prop {String} [errorMessages=''] - 表示エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-checkbox/
 * @example
 * <dd-checkbox
 *   v-model="checkValue"
 *   :required="true"
 *   tooltipText="ツールチップテキスト"
 *   :enableToolTip="true"
 *   :tooltipLeft="true"
 * />
 */
export default {
  name: 'DdCheckbox',
  extends: VCheckbox,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * ツールチップテキスト
     */
    onIcon: {
      type: String,
      default: undefined
    },
    offIcon: {
      type: String,
      default: undefined
    },
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示までのラグ
     */
    tooltipDelay: {
      type: Number,
      default: 1000
    },
    /**
     * サイズ
     */
    large: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    this[controls.VALIDATE_METHOD]()
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        hideDetails: true,
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        falseValue: false,
        trueValue: true,
        style: this.large ? 'transform: scaleX(1.1) !important' : ''
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e)
      }
    },
    hasError () {
      return this.invalidMessage
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }

      this.invalidMessage = undefined
      const validatorList = []

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
</style>
